import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { toastError } from '../toast';

const stopImitation: sharedTypes.AppThunk =
  () =>
  async (dispatch, getState, { gateways, stores }) => {
    const state: any = getState();
    const orgId = state.auth.orgId;
    const userId = state.auth.userId;

    try {
      await gateways.token.delete({ orgId, userId });
    } catch (err) {
      dispatch(toastError('Failed to end impersonated session correctly. Please try again.'));
      return;
    }

    stores.auth.remove();
    window.location.replace('/admin/imitate');
  };

export default stopImitation;
